/**
 * Sistema
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {SistemaCollection} from '@/model/collection/SistemaCollection'

/* TODO: review generated class */
export class Sistema extends Resource {
  idSistemaPk: number = 0

  nome: string | null = null
  ativo: boolean | null = null

  get $id() {
    return this.idSistemaPk
  }
  set $id(val) {
    this.idSistemaPk = val
  }
  get $tag() {
    return String(this.nome)
  }

  /**
   * Gets a instance of a given ID of Sistema
   */
  async getSistema(id: number) {
    return await Request.get(`/admin/sistema/${id}`)
      .name('getSistema')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of Sistema
   */
  async removeSistema() {
    return await Request.delete(`/admin/sistema/${this.$id}`)
      .name('removeSistema')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of Sistema
   */
  static async listSistema(params: any) {
    return await Request.get(`/admin/sistema`, {params})
      .name('listSistema')
      .as(SistemaCollection)
      .getData()
  }

  /**
   * Persists a new instance of Sistema. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistSistema() {
    return await Request.post(`/admin/sistema`, this)
      .name('persistSistema')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of Sistema to use it in a CSV file
   */
  static async listCsvSistema(params: any) {
    return await Request.get(`/admin/sistema/csv`, {params})
      .name('listCsvSistema')
      .as(SistemaCollection)
      .getData()
  }
}
